import { Modal } from '@ts/components/Modal';

export const init = () => {
    setWhatIsThisModals();
}

const setWhatIsThisModals = () => {
    const whatIsThisTriggers = document.querySelectorAll('.wit-modal');

    if (whatIsThisTriggers.length === 0) return;

    whatIsThisTriggers.forEach(trigger => {
        trigger.addEventListener('click', (e) => {
            e.preventDefault();
            const modalContent = trigger.dataset.witContent || 'No information available.';
            const modalTitle = trigger.dataset.witTitle || 'What Is This?';
            Modal.createAlertModal({
                title: modalTitle,
                message: modalContent
            });
        });
    });
}